import configApi from '@/request/configApi/configApi'

const END_POINT = 'marketplace-public-configuration'

const fetchMarketplacePublicConfigurationRequest = (source, queryParams) => configApi.get(END_POINT, { params: queryParams })

export default fetchMarketplacePublicConfigurationRequest
